


//var csv is the CSV file with headers
export const CSVJSON = csv => {
  var lines = csv.split("\n");
  var result = {};
  var headers = lines[0].split(",");
  for (let j = 0; j < headers.length; j++) {
      result[headers[j]] = [];
  }

  for (let i = 1; i < lines.length; i++) {
      const data = lines[i].split(',');
      for (let j = 0; j < headers.length; j++) {
          if (!result[headers[j]]) {
              result[headers[j]] = [];
          }
          const value = data[j];
          if (!isNaN(value)) {
              result[headers[j]].push(Number(value));
          } else {
              result[headers[j]].push(value);
          }
      }
  }
  return result; //JavaScript object
  // return JSON.stringify(result); //JSON
}

export const CSVTOJSON2 = (csv) => {
  const lines = csv.split("\n");
  const result = [];
  const headers = lines[0].split(",");

  for (let i = 1; i < lines.length; i++) {
    if (lines[i].trim() !== "") {
      const obj = {};
      const currentline = lines[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
      for (let j = 0; j < headers.length; j++) {
        obj[headers[j].trim()] = currentline[j]?.trim();
      }
      result.push(obj); // ✅ only push non-empty row
    }
  }
  return result;
};


export function DateFrequency(dayDiff) {
    if (dayDiff === 1) return "daily";
    if (dayDiff >= 6 && dayDiff <= 8) return "weekly";
    if (dayDiff >= 28 && dayDiff <= 31) return "monthly";
    if (dayDiff >= 89 && dayDiff <= 92) return "quarterly";
    return "unknown";
}
